import { useState } from "react";
import "./footerLanding.css";
import { useHomeContent } from "../../../pages/Landing/hooks/useHomeContent";
import { FeedbackModal } from "../modals/FeedbackModal/FeedbackModal";

export const FooterLanding = () => {
  const data = useHomeContent();
  const [feedbackOpen, setFeedbackOpen] = useState(false);

  if (!data?.footer) return null;
  const f = data.footer;
  const feedbackModal = data.feedbackModal ?? {};

  const hotlinePhone = f.hotlinePhone ?? f.phone;
  const hotlinePhoneHref = f.hotlinePhoneHref ?? f.phoneHref;
  const hotlineEmail = f.hotlineEmail ?? f.email;

  const tenderPhone = f.tenderPhone ?? f.phone;
  const tenderPhoneHref = f.tenderPhoneHref ?? f.phoneHref;
  const tenderEmail = f.tenderEmail ?? f.email;

  return (
    <>
      <footer className="oc-footer">
        <div className="oc-container">
          <div className="oc-footer__row">
            <div className="oc-footer__logoCol">
              <img
                src={f.logo}
                alt={f.logoAlt ?? "logo"}
                className="oc-footer__logo"
              />
            </div>

            <div className="oc-footer__col">
              <div className="oc-footer__title">{f.hotlineTitle}</div>

              <a className="oc-footer__item" href={`tel:${hotlinePhoneHref}`}>
                <span
                  className="oc-footer__icon oc-footer__icon--phone"
                  style={{
                    WebkitMaskImage: `url(/assets/icons/phone.svg)`,
                    maskImage: `url(/assets/icons/phone.svg)`,
                  }}
                />
                <span>{hotlinePhone}</span>
              </a>

              <a className="oc-footer__item" href={`mailto:${hotlineEmail}`}>
                <span
                  className="oc-footer__icon oc-footer__icon--email"
                  style={{
                    WebkitMaskImage: `url(/assets/icons/email.svg)`,
                    maskImage: `url(/assets/icons/email.svg)`,
                  }}
                />
                <span>{hotlineEmail}</span>
              </a>
            </div>

            <div className="oc-footer__col">
              <div className="oc-footer__title">{f.tenderTitle}</div>

              <a className="oc-footer__item" href={`tel:${tenderPhoneHref}`}>
                <span
                  className="oc-footer__icon oc-footer__icon--phone"
                  style={{
                    WebkitMaskImage: `url(/assets/icons/phone.svg)`,
                    maskImage: `url(/assets/icons/phone.svg)`,
                  }}
                />
                <span>{tenderPhone}</span>
              </a>

              <a className="oc-footer__item" href={`mailto:${tenderEmail}`}>
                <span
                  className="oc-footer__icon oc-footer__icon--email"
                  style={{
                    WebkitMaskImage: `url(/assets/icons/email.svg)`,
                    maskImage: `url(/assets/icons/email.svg)`,
                  }}
                />
                <span>{tenderEmail}</span>
              </a>
            </div>

            <div className="oc-footer__col">
              <div className="oc-footer__title">{f.writeTitle}</div>

              <button
                className="oc-footer__btn oc-footer__btn--outline"
                type="button"
                onClick={() => setFeedbackOpen(true)}
              >
                {f.feedbackLabel}
              </button>
            </div>

            <div className="oc-footer__col oc-footer__col--right">
              <div className="oc-footer__title">{f.productsTitle}</div>

              <a
                className="oc-footer__btn oc-footer__btn--primary"
                href={f.catalogUrl}
                target="_blank"
                rel="noreferrer"
              >
                <span
                  className="oc-footer__icon oc-footer__icon--download"
                  style={{
                    WebkitMaskImage: `url(/assets/icons/download.svg)`,
                    maskImage: `url(/assets/icons/download.svg)`,
                  }}
                />
                {f.catalogLabel}
              </a>
            </div>
          </div>
        </div>
      </footer>

      <FeedbackModal
        open={feedbackOpen}
        onClose={() => setFeedbackOpen(false)}
        title={feedbackModal.title}
        thanksText={feedbackModal.thanksText}
        submitLabel={feedbackModal.submitLabel}
        formCopy={data.feedbackForm}
      />
    </>
  );
};
